var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M10.792 9.066l3.039 2.66c.62.542.683 1.485.14 2.105l-.067.073a1.492 1.492 0 0 1-2.11 0c-.036-.036-.036-.036-.069-.073l-2.659-3.039a5 5 0 1 1 1.726-1.726zM6.5 10.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm3.484-.177l2.494 2.85c.01.012.01.012.022.023a.492.492 0 0 0 .696 0l.023-.023a.492.492 0 0 0-.046-.695l-2.85-2.494-.339.339z" })
  );
});